import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {FINESTRE_PREDEFINITE, SinotticoRichiesta} from '../_models/SinotticoFiltro';
import {SinotticoRisorsa} from '../_models/SinotticoRisorsa';
import {SinotticoDettaglioRisorsa} from '../_models/SinotticoDettaglio';

/**
 * Le chiamate HTTP del Sinottico verso il proprio endpoint.
 *
 * `getStatoRisorse` è uno **snapshot di bootstrap**, non un endpoint di polling: viene invocata all'ingresso nella
 * pagina e dopo il ripristino di una connessione real-time caduta (FR-014, FR-015). Qualunque
 * chiamata periodica è una violazione del contratto della feature, non un'ottimizzazione
 * discutibile.
 *
 * ⚠️ Il parametro è **`orgId`**, non `organizzazioneId`: il refuso non produce errori, il valore
 * arriva a `0` e la pagina resta vuota — indistinguibile da un'organizzazione senza risorse.
 */
@Injectable({providedIn: 'root'})
export class SinotticoService {
  constructor(private http: HttpClient) {}

  getStatoRisorse(richiesta: SinotticoRichiesta): Promise<SinotticoRisorsa[]> {
    const parametri = `orgId=${richiesta.orgId}`
      + `&finestraMinuti=${richiesta.finestraMinuti}`
      + `&finestraTerminatiMinuti=${richiesta.finestraTerminatiMinuti}`;

    return firstValueFrom(
      this.http.get<SinotticoRisorsa[]>(
        `${environment.localApiUrl}api/Sinottico/GetStatoRisorse?${parametri}`)
    );
  }

  /**
   * Ordini assegnati e ultimi eventi della risorsa (feature 147, US4). Si chiama **solo**
   * all'apertura del pannello o al cambio di risorsa: mai al caricamento della pagina, mai su push.
   * Un errore arriva al chiamante, che lo dichiara nel pannello invece di mostrare un elenco vuoto.
   */
  getDettaglioRisorsa(orgId: number, risorsaId: number): Promise<SinotticoDettaglioRisorsa> {
    return firstValueFrom(
      this.http.get<SinotticoDettaglioRisorsa>(
        `${environment.localApiUrl}api/Sinottico/GetDettaglioRisorsa/${orgId}/${risorsaId}`)
    );
  }

  /** Le due finestre della richiesta, con i valori predefiniti del contratto. */
  richiestaPer(orgId: number): SinotticoRichiesta {
    return {orgId, ...FINESTRE_PREDEFINITE};
  }
}
